const colorSchemes = {
  rainbow: [
    "#2563EB",
    "#D4740C",
    "#148F77",
    "#0284C7",
    "#475569",
    "#6366f1",
    "#A51C30",
  ],

  gray: ["#1F2937", "#374151", "#4B5563", "#6B7280", "#9CA3AF", "#D1D5DB"],

  gray_plus: [
    "rgba(237, 221, 83, 1)",
    "rgba(31, 41, 55, 0.4)",
    "rgba(55, 65, 81, 0.4)",
    "rgba(75, 85, 99, 0.4)",
    "rgba(107, 114, 128, 0.4)",
    "rgba(156, 163, 175, 0.4)",
    "rgba(209, 213, 219, 0.4)",

    "rgba(31, 41, 55, 0.4)",
    "rgba(55, 65, 81, 0.4)",
    "rgba(75, 85, 99, 0.4)",
    "rgba(107, 114, 128, 0.4)",
    "rgba(156, 163, 175, 0.4)",
    "rgba(209, 213, 219, 0.4)",
  ],

  gray_plus_03: [
    "rgba(237, 221, 83, 1)",
    "rgba(31, 41, 55, 0.3)",
    "rgba(55, 65, 81, 0.3)",
    "rgba(75, 85, 99, 0.3)",
    "rgba(107, 114, 128, 0.3)",
    "rgba(156, 163, 175, 0.3)",
    "rgba(209, 213, 219, 0.3)",

    "rgba(31, 41, 55, 0.3)",
    "rgba(55, 65, 81, 0.3)",
    "rgba(75, 85, 99, 0.3)",
    "rgba(107, 114, 128, 0.3)",
    "rgba(156, 163, 175, 0.3)",
    "rgba(209, 213, 219, 0.3)",
  ],

  // yellow: ["rgba(237, 221, 83, 1)", "rgba(75, 85, 99, 1)", "rgba(75, 85, 99, 1)"],
};

export { colorSchemes };
